var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTablet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5903_29905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8237 26.843L34.8237 6.52931C34.8237 4.52695 33.1986 2.90186 31.1963 2.90186L3.62765 2.90185C1.6253 2.90185 0.000202108 4.52695 0.00020202 6.5293L0.000201132 26.843C0.000201045 28.8454 1.6253 30.4705 3.62765 30.4705L31.1963 30.4705C33.1986 30.4705 34.8237 28.8454 34.8237 26.843ZM1.45118 16.6862C1.45118 15.4819 2.42334 14.5097 3.62765 14.5097C4.83197 14.5097 5.80412 15.4819 5.80412 16.6862C5.80412 17.8905 4.83197 18.8626 3.62765 18.8626C2.42334 18.8626 1.45118 17.8905 1.45118 16.6862ZM7.2551 27.5685L7.2551 5.80382L30.4708 5.80382L30.4708 27.5685L7.2551 27.5685Z",
    fill: "#8F9BB3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5903_29905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.8235,
    height: 34.8235,
    fill: "white",
    transform: "translate(34.8237) rotate(90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.09ff56a2738f21f173c5c91e10fcb0cd.svg";
export { ForwardRef as ReactComponent };